import {SHType} from "../common/SHType";

export enum MediaStateTypeId {
    Active = 1,
    Inactive = 2
}

class _MediaStateType extends SHType<MediaStateTypeId> {

    constructor() {
        super(
            "MediaStateType",
            [
                [MediaStateTypeId.Active, "active"],
                [MediaStateTypeId.Inactive, "inactive"]
            ]
        );
    }

}

//added suffix "Obj" to avoid conflict with legacy MediaStateType enum
export const MediaStateTypeObj = new _MediaStateType();
